// Combine the different reducers
import { combineReducers } from 'redux';
import { ToastReducer } from 'Containers/Toast/reducers/toast.reducers';
import { ModalReducer } from 'Containers/Modal/reducers/modal.reducers';
import { FilterReducer } from 'Containers/Filter/reducers/filter.reducer';
import { IndividualListReducer } from 'Containers/AudienceExplore/reducers/individuallist.reducers';
import { AttributesReducer } from 'Containers/Attributes/reducers/attributes.reducer';
import { GoodDataReducer } from 'Containers/GoodData/reducers/goodData.reducer';
import { FullAccessReducer } from 'Containers/FullAccess/reducers/fullaccess.reducers';
import { AnalyticsReducer } from '../shared/analyticsManager';

export default combineReducers({
  attributes: AttributesReducer,
  filter: FilterReducer,
  toast: ToastReducer,
  modal: ModalReducer,
  individualList: IndividualListReducer,
  goodData: GoodDataReducer,
  fullAccess: FullAccessReducer,
  analyticsManager: AnalyticsReducer,
});
